// extracted by mini-css-extract-plugin
export default {"continueMergeProp":"LoanPropertyValueCell_continueMergeProp__3AhoW","iconTypography":"LoanPropertyValueCell_iconTypography__ZM0HU"};